package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class NotificationsResponse(
    val data: List<NotificationsList>,
    val totalCount: Long,
    val unreadCount: Long,
)

@Serializable
data class NotificationsList(
    @SerialName("_attachments")
    val attachments: String,
    @SerialName("_etag")
    val etag: String,
    @SerialName("_rid")
    val rid: String,
    @SerialName("_self")
    val self: String,
    @SerialName("_ts")
    val ts: Long,
    val category: String = "",
    val id: String,
    val isRead: Boolean = false,
    val isAdminRead: Boolean = true,
    val message: String = "",
    val organization: String,
    val playerEmail: String? = null,
    val playerName: String? = null,
    @SerialName("receiverID")
    val receiverId: String,
    @SerialName("senderID")
    val senderId: String = "",
    val senderTimeMillisec: String? = null,
    @SerialName("sessionID")
    val sessionId: String? = null,
    val timestamp: String = "",
    val title: String,
    val sessionType: String? = null,
    val type: String,
    val adminMessage: String? = null,
    val reminder: Long? = null,
    val senderEmail: String? = null,
    val senderName: String? = null,
    val requestedBy: String? = null,
    val status: String? = null,
)


@Serializable
data class NotificationsPayload(
    @SerialName("senderID")
    val senderId: String? = null,

    @SerialName("receiverID")
    val receiverId: String? = null,
    val role: String? = null,
    val organization: String,
    val seasonID: String
)

@Serializable
data class AllReadResponse(
    val updatedCount: Long,
)


@Serializable
data class AllReadPayload(
    @SerialName("userID")
    val userId: String? = null,
    val organization: String,
    val markAs: String,
)

